<mat-sidenav-container #sidenav fullscreen>
  <mat-sidenav style="padding: 0;  background: #fafafa; width: 50%"
               [style.width]="coreConfiguration.isMobile? '50%' : '300px'"
               [mode]="coreConfiguration.isMobile ? 'over' : 'side'" [disableClose]="false"
               [opened]="!coreConfiguration.isMobile && isLoggedIn() && !isShowingAppUpdates">
    <mat-toolbar color="primary">
      <mat-toolbar-row>
        <svg style="margin-right: 0.3em; width:36px;height:36px" viewBox="0 0 24 24">
          <path fill="#FFFFFF"
                d="M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z"/>
        </svg>
        <span style="font-size: 22px">TaskR</span>
      </mat-toolbar-row>
    </mat-toolbar>
    <p style="text-align: left; font-size: smaller; padding: 0.5em 0.5em 0.5em 1.5em; margin: 0; font-family: sans-serif; color: white; background-color: #4fc3f7">{{getVersionString()}}</p>
    <app-admin-menu (onLogout)="logout()"></app-admin-menu>
  </mat-sidenav>
  <mat-sidenav-content style="background: #fff">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
